import { render } from "./leftNav.vue?vue&type=template&id=6bb719be&scoped=true&lang=html"
import script from "./leftNav.vue?vue&type=script&lang=js"
export * from "./leftNav.vue?vue&type=script&lang=js"

import "./leftNav.vue?vue&type=style&index=0&id=6bb719be&lang=scss&scoped=true"

import exportComponent from "D:\\work\\Organizationpersonnel\\organization_personnel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb719be"]])

export default __exports__